var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrownie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.2 249.4",
    enableBackground: "new 0 0 167.2 249.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -18.2,
    y: 23,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 23,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 23,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.1,
    y: 23,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.2,
    y: 23,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.2,
    y: 23,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.3,
    y: 23,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.2,
    y: 52,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 52,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 52,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.1,
    y: 52,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.2,
    y: 52,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.2,
    y: 52,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.3,
    y: 52,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -18.2,
    y: -6.1,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: -6.1,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: -6.1,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.1,
    y: -6.1,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.2,
    y: -6.1,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.2,
    y: -6.1,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.3,
    y: -6.1,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -18.2,
    y: 226.5,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 226.5,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 226.5,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.1,
    y: 226.5,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.2,
    y: 226.5,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.2,
    y: 226.5,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.3,
    y: 226.5,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: -18.2,
    y: 81.1,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 81.1,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 81.1,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.1,
    y: 81.1,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.2,
    y: 81.1,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.2,
    y: 81.1,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.3,
    y: 81.1,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.2,
    y: 110.2,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 110.2,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 110.2,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.1,
    y: 110.2,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.2,
    y: 110.2,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.2,
    y: 110.2,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.3,
    y: 110.2,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.2,
    y: 139.3,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 139.3,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 139.3,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.1,
    y: 139.3,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.2,
    y: 139.3,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.2,
    y: 139.3,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.3,
    y: 139.3,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.2,
    y: 168.3,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 168.3,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 168.3,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.1,
    y: 168.3,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.2,
    y: 168.3,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.2,
    y: 168.3,
    fill: "#C62127",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.3,
    y: 168.3,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18.2,
    y: 197.4,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 197.4,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 197.4,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.1,
    y: 197.4,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.2,
    y: 197.4,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 127.2,
    y: 197.4,
    fill: "#D97983",
    width: 29.1,
    height: 29.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.3,
    y: 197.4,
    fill: "#FFFFFF",
    width: 29.1,
    height: 29.1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F1F2F2",
    cx: 83.6,
    cy: 152.7,
    rx: 64.6,
    ry: 25.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#D1D3D4",
    cx: 84.3,
    cy: 153,
    rx: 45.4,
    ry: 13.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74AF60",
    d: "M110.3,148.6c0,0-1.5-6.8,0.8-11.1c0,0,0.2,0.8,0.4,0.8c0.2,0,0.1-2,0.5-2.7c0.4-0.6,1.7-1.1,1.7-1.1 s-0.4,0.7-0.2,0.8c0.2,0.1,1.4-1.7,1.9-1.9c0,0,0,0.9,0.2,0.6c0.2-0.3,1.2-1.6,2.1-1.8c0,0-0.2,0.8,0,0.9c0.2,0,1.1-1.6,1.8-1.8 c0.7-0.2,1.5-0.6,1.8-0.9c0,0,0,0.7,0.3,0.7c0.3,0,0.9-0.7,1-1.3s2.2-1.7,2.2-1.7s-0.2,1.2,0,1.1c0.2,0,0.8-1,0.9-1.5 c0.2-0.5,1.4-1.2,1.6-1.5c0,0,0.3,1.2,0.5,1.1c0.2-0.1,0.4-0.8,1.1-1.5c0.7-0.7,1.9-1.2,1.9-1.2s0,0.8,0.2,0.7 c0.2-0.1,0.1-0.7,0.1-0.7s0.9-0.4,1.1-0.3s1.5,2.3,1.3,3.6l0.5-0.2c0,0,0.8,3,0,4.5c0,0-0.2,0.4,0.2,0.4c0,0,0.6,1.9-0.7,4.4 c0,0-0.5,1.5-0.5,2.2s-0.7,1.5-0.9,1.7c-0.2,0.2-0.8,1.8-1,2.7c-0.2,0.9-1.2,2.9-3.4,4c-2.2,1-2.7,2.6-3.3,3.2 S118.7,155.9,110.3,148.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89C97F",
    d: "M112,151c0,0,4.1,4.1,8.1,4.3c0,0-0.5-0.5-0.4-0.6c0.1-0.1,1.5,0.8,2.1,0.8c0.6,0,1.5-0.7,1.5-0.7 s-0.6,0-0.6-0.2c0-0.2,1.8-0.3,2.1-0.5c0,0-0.6-0.4-0.3-0.4c0.3,0,1.6-0.1,2.2-0.7c0,0-0.7-0.2-0.6-0.4c0.1-0.2,1.6-0.1,2.1-0.5 c0.4-0.4,1.1-0.8,1.4-0.8c0,0-0.5-0.3-0.3-0.5c0.2-0.2,0.9-0.3,1.4-0.1c0.5,0.2,2.1-0.8,2.1-0.8s-0.9-0.4-0.8-0.5 c0.1-0.1,1-0.1,1.4,0c0.4,0.1,1.5-0.4,1.7-0.5c0,0-0.7-0.7-0.5-0.8c0.2-0.1,0.7,0.1,1.6-0.1s1.7-0.8,1.7-0.8s-0.6-0.3-0.4-0.4 c0.2-0.1,0.6,0.2,0.6,0.2s0.7-0.5,0.7-0.7c0.1-0.2-0.9-2-2-2.5l0.4-0.3c0,0-1.7-1.9-3.2-2c0,0-0.4-0.1-0.2-0.3c0,0-1-1.3-3.4-1.4 c0,0-1.3-0.3-1.8-0.6c-0.5-0.3-1.3-0.1-1.6-0.1c-0.3,0.1-1.6-0.2-2.3-0.5c-0.7-0.2-2.6-0.4-4.2,0.6c-1.7,1.1-3,0.7-3.7,0.9 C116.2,140.2,110.6,142,112,151z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#73453D",
    d: "M40.8,153.5c0,0,3.7,3.4,7.1,4.9c3.4,1.5,8.8,2.8,10.5,3.7c1.7,0.9,12.8,6.3,14.4,7.1 c1.7,0.8,8.9,4.5,9.8,4.6c0.9,0.2,15.7-4.9,18.3-7.2c2.6-2.3,8.9-4.6,10.5-4.9c1.5-0.3,14.1-5.8,14.8-8.1 C126.9,151.1,40.8,153.5,40.8,153.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#73453D",
    points: "83.5,105.7 40.8,123.9 40.8,153.5 83.5,173.1 126.2,153.5 126.2,123.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#543A32",
    points: "83.5,105.7 40.8,123.9 83.5,144.5 126.2,123.9  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9121 0.41 -0.41 0.9121 65.3148 -9.3465)",
    fill: "#543A32",
    cx: 54.5,
    cy: 147.6,
    rx: 8,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9159 -0.4015 0.4015 0.9159 -52.0823 57.9254)",
    fill: "#543A32",
    cx: 112.2,
    cy: 153.2,
    rx: 5.3,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9159 -0.4015 0.4015 0.9159 -50.5756 51.5222)",
    fill: "#543A32",
    cx: 97.6,
    cy: 146.4,
    rx: 11.4,
    ry: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9121 0.41 -0.41 0.9121 70.6423 -11.9726)",
    fill: "#543A32",
    cx: 63.2,
    cy: 158.7,
    rx: 12.8,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#543A32",
    cx: 73,
    cy: 152.4,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#543A32",
    cx: 99.4,
    cy: 152.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#543A32",
    cx: 90,
    cy: 165.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#543A32",
    cx: 117.9,
    cy: 134.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#543A32",
    cx: 49.2,
    cy: 134.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#543A32",
    d: "M40.8,123.9c0,0,1.7,3.2,5.1,4.8c3.5,1.6,4.8,0.5,6.9,1.6c2.1,1.2,6.7,4,9.2,5.5 c20.1,12.2,26.7,11.3,33.9,3.9c1.4-1.5,3.7-3,5.3-2.1c1.6,0.9,5.1-0.2,5.5-2.1c0.5-1.8,1.2-3.5,2.5-3.5s11.3-2.5,13.6-4.4 c2.3-1.8,3.3-3.9,3.3-3.9H40.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A97C50",
    d: "M56.9,151c6.6-1.4,10.8,1,11.6,5c0.9,4-1.9,8-8.5,9.4s-12.6-1-15.9-4.1C46.2,157.4,50.3,152.5,56.9,151z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#762B17",
    d: "M61.3,163.4l-0.1-0.4c1.6-0.5,3-1.3,3.9-2.3c0.9-1,1.2-2,1-2.8l0.4-0.1c0.3,1-0.1,2.2-1.1,3.3 C64.4,162,62.9,162.8,61.3,163.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#762B17",
    d: "M56.6,162.6l0.1-0.5c0.8,0.1,1.6,0.1,2.2-0.2c0.6-0.3,1-0.7,1.1-1.2l0.5,0.1c-0.1,0.6-0.6,1.2-1.3,1.5 C58.4,162.7,57.5,162.7,56.6,162.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#762B17",
    d: "M48.5,158.3l-0.4-0.3c2.5-3,5.8-5,9.3-5.7c3.5-0.7,6.8,0.1,9.2,2.1l-0.3,0.4c-2.3-2-5.5-2.7-8.8-2 C54.2,153.4,51,155.4,48.5,158.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#762B17",
    d: "M63.6,159l-0.4-0.2c0.7-1.2,0.2-2.8-1.1-3.4l0.2-0.4C63.8,155.8,64.4,157.6,63.6,159z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48.2,
    y: 162.8,
    transform: "matrix(0.9552 0.2958 -0.2958 0.9552 50.4799 -7.6588)",
    fill: "#762B17",
    width: 4.7,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.1,
    y: 155.4,
    transform: "matrix(0.357 0.9341 -0.9341 0.357 181.7456 48.9612)",
    fill: "#762B17",
    width: 0.5,
    height: 2.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 155.7,
    transform: "matrix(0.2501 0.9682 -0.9682 0.2501 196.1419 64.2183)",
    fill: "#762B17",
    width: 0.5,
    height: 6.2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "spoon_1_",
    fill: "#A7A9AC",
    d: "M78.3,129.6c7.5,2.3,14-11.4,15.7-16.7c1.5-4.7-3-9.6-3-9.6c-1.1-1.2-1.5-3.5-1-5 c0,0,14.6-38.8,15.3-41c1-3-0.1-6.1-2.3-6.7c-2.2-0.7-4.8,1.2-5.7,4.2C96.7,57,86.6,97.2,86.6,97.2c-0.4,1.6-2.1,3.2-3.7,3.6 c0,0-6.4,1.5-7.9,6.2C73.3,112.2,70.9,127.2,78.3,129.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9937 0.1118 -0.1118 0.9937 13.6097 -8.1705)",
    opacity: 0.2,
    fill: "#F1F2F2",
    cx: 79.7,
    cy: 117.3,
    rx: 2.6,
    ry: 6.7
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#543A32",
    cx: 74,
    cy: 129.4,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#543A32",
    cx: 80.4,
    cy: 130.2,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#543A32",
    cx: 85.3,
    cy: 130.2,
    r: 3.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrownie);
export default __webpack_public_path__ + "static/media/brownie.802491ea1c33e04d747dc0dfc242f524.svg";
export { ForwardRef as ReactComponent };